import React from 'react';
import '../styles/SettingsModal.css';

const SettingsModal = ({
  show,
  onClose,
  autoClassify,
  setAutoClassify,
  autoSentiment,
  setAutoSentiment,
}) => {
  if (!show) return null;

  return (
    <div className="settings-modal-overlay" onClick={onClose}>
      <div className="settings-modal" onClick={e => e.stopPropagation()}>
        <h2>Settings</h2>

        <div className="settings-toggle">
          <input
            id="auto-classify-toggle"
            type="checkbox"
            checked={autoClassify}
            onChange={(e) => setAutoClassify(e.target.checked)}
          />
          <label htmlFor="auto-classify-toggle">Auto Classify New Nodes</label>
        </div>

        <div className="settings-toggle">
          <input
            id="auto-sentiment-toggle"
            type="checkbox"
            checked={autoSentiment}
            onChange={(e) => setAutoSentiment(e.target.checked)}
          />
          <label htmlFor="auto-sentiment-toggle">Auto Sentiment New Nodes</label>
        </div>

        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default SettingsModal;
